"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.compatibility = void 0;
const service_1 = require("./ngx-device-detector/service");
const service = new service_1.DeviceDetectorService();
function compatibility(check) {
    return check(Object.assign(Object.assign({}, service.getDeviceInfo()), { isDesktop: service.isDesktop(), isTablet: service.isTablet(), isMobile: service.isMobile() }));
}
exports.compatibility = compatibility;
//# sourceMappingURL=compatibility.js.map